import { render, staticRenderFns } from "./LocalizacaoCadastro.vue?vue&type=template&id=7b3e5890"
import script from "./LocalizacaoCadastro.vue?vue&type=script&lang=js"
export * from "./LocalizacaoCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports